import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';

import ButtonWithLoadingIndicator from '../../shared/ButtonWithLoadingIndicator/ButtonWithLoadingIndicator';
import SecondaryButton from '../../shared/SecondaryButton/SecondaryButton';
import { callApi, MESSAGES, SUPPRESS } from '../../utils/api';
import WebViewContext from '../../utils/webview-context';
import styles from './DeleteModal.module.scss';

const DeleteModal = ({
  apiKey,
  baseUrl,
  closeModal,
  message: msgToDelete,
  navigationState,
  setRequestStatus,
  transition,
  updateInboxMessageCache,
  updateSentMessageCache
}) => {
  const [, setDeleteRequestStatus] = useState(-1);

  const confirmDelete = () => {
    const defaultExpiration = new Date();
    defaultExpiration.setYear(3000);
    msgToDelete.createdTimestamp = msgToDelete.createdTimestamp
      ? new Date(msgToDelete.createdTimestamp).getTime()
      : new Date().getTime();
    msgToDelete.expiresTimestamp = msgToDelete.expiresTimestamp
      ? new Date(msgToDelete.expiresTimestamp).getTime()
      : defaultExpiration.getTime();
    msgToDelete.replyId = msgToDelete.replyId ? msgToDelete.replyId : '-1';
    callApi(baseUrl, apiKey, SUPPRESS, msgToDelete)
      .then(deleteResponse => {
        setDeleteRequestStatus(deleteResponse.status);
        callApi(baseUrl, apiKey, MESSAGES)
          .then(response => {
            const msgs = response.json();
            setRequestStatus(response.status);
            msgs.then(messages => {
              const { inbox, sent } = messages;
              updateInboxMessageCache(inbox);
              updateSentMessageCache(sent);
              if (navigationState !== 'INBOX') {
                transition('back');
              }
              closeModal();
            });
          })
          .catch(err => {
            setRequestStatus(500);
            console.error(err);
          });
      })
      .catch(err => {
        setDeleteRequestStatus(500);
        console.error(err);
      });
  };

  const isCustomerWebView = useContext(WebViewContext);
  return (
    <div className={styles['modal-container']}>
      <div className={styles.message}>
        Are you sure you want to delete this message?
      </div>
      <div className={styles['button-container']}>
        <SecondaryButton
          className={`${styles['link-button']} close-modal`}
          onClick={() => {
            closeModal();
          }}
        >
          Cancel
        </SecondaryButton>
        <ButtonWithLoadingIndicator
          className="confirm-delete branded-button"
          disabled={isCustomerWebView}
          onClick={confirmDelete}
          onLoadComplete={() => {}}
        >
          Yes
        </ButtonWithLoadingIndicator>
      </div>
    </div>
  );
};

DeleteModal.propTypes = {
  apiKey: PropTypes.string,
  baseUrl: PropTypes.string,
  closeModal: PropTypes.func,
  message: PropTypes.object,
  navigationState: PropTypes.string,
  setRequestStatus: PropTypes.func,
  transition: PropTypes.func,
  updateInboxMessageCache: PropTypes.func,
  updateSentMessageCache: PropTypes.func
};

export default DeleteModal;
